import i18n, { InitOptions } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { get } from 'local-storage'
import { initReactI18next } from 'react-i18next'

import config from '@/config/index'
import { pluralise } from '@/utils/pluralise'

const LANGUAGE_KEY = 'i18nextLng'

const options: InitOptions = {
  ns: [
    'abn',
    'action',
    'common',
    'communication',
    'dashboard',
    'document',
    'defect',
    'drawings',
    'induction',
    'insurance',
    'integration',
    'librarySwms',
    'project',
    'permit',
    'prequalification',
    'notifications',
    'siteInduction',
    'siteDiary',
    'subcontractor',
    'swms',
    'swmsBuilder',
    'ticket',
    'toolbox',
    'timesheet',
    'worker',
  ],
  // Set fallback language to English
  fallbackLng: 'en',
  lng: get(LANGUAGE_KEY) || 'en',
  // Enable debug mode in development environment
  debug: process.env.I18NEXT_DEBUG === 'true',
  interpolation: {
    // Disable escaping to prevent XSS attacks (React already safeguards against it)
    escapeValue: false,
  },
  backend: {
    // Appends a unique build version to prevent caching issues and ensure fresh translation files after each deployment
    loadPath: `/locales/{{lng}}/{{ns}}.json?v=${config.version}`,
  },
}

/**
 * @TODO
 *
 * Consider implementing https://locize.com/ here. Advantages include:
 * - Continuous localization
 * - In-context editing
 * - Version control for translations
 * - Automated translation workflows
 * - Real-time updates without app redeployment
 */

i18n
  // Use Backend plugin to load translations via http
  // Translations are expected to be in /public/locales directory
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(options)

// Custom formatters
// Lowercase
i18n.services.formatter.add('lowercase', (value, lng, _options) => {
  return value.toLocaleLowerCase(lng)
})
// Titlecase (Capitalize only first character of the whole string)
i18n.services.formatter.add('titlecase', (value, lng, _options) => {
  return value
    ? value[0].toLocaleUpperCase(lng) + value.slice(1).toLocaleLowerCase(lng)
    : ''
})
// Pluralise
i18n.services.formatter.add('pluralise', (value, _lng, options) => {
  const count = options.count || 0
  return pluralise(count, value)
})

export default i18n
